
import { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "antd";
import { Input } from "antd";
import { useTranslation } from "react-i18next";
import { TranslationData } from "../../../../../models/MappingData";
import { BudgetData, CreateBudgetDto, EditBudgetDto } from "../../../../../models/ConfigurationData";
import { createBudgetGroupForm, editBudgetGroupForm, fetchLanguagesAvailables } from "../../../../../api/repositoryEP";
import { LoadingOutlined } from "@ant-design/icons";
import { LoadingData } from "../../../../common";


interface BudgetFormProps {
    drawerVisible: boolean;
    setDrawerVisible: (visible: boolean) => void;
    budgetData: BudgetData[] | null;
    setBudgetData: (budgetData: BudgetData[] | null) => void;
    onSuccess?: () => void;
    mode: "create" | "edit"
}


const BudgetForm = (props: BudgetFormProps): JSX.Element => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [budgets, setBudgets] = useState<Array<BudgetData>>([]);
    const isArray = Array.isArray(budgets);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingButton, setLoadingButton] = useState<boolean>(false);


    const closeDrawer = () => {
        props.setBudgetData(null)
        setBudgets([]);
        form.resetFields();
        props.setDrawerVisible(false)
    }


    const modifyBudgetName = (index: number, value: string) => {
        const newBudgets = [...budgets];
        newBudgets[index].name = value;
        setBudgets(newBudgets);
        form.validateFields(["budgetsValidator"]);

    }


    const handleBtnCancel = () => {
        closeDrawer();
    }

    useEffect(() => {
        if (!props.drawerVisible) return;

        if (props.mode === "edit" && props.budgetData) {
            setBudgets(props.budgetData);
            form.setFieldsValue({ budgets: props.budgetData });
        } else {
            setLoading(true);

            fetchLanguagesAvailables("wa").then((r) => {
                if (r?.type === 1) {
                    const initialBudgets: BudgetData[] = r.data.map((lang: string) => ({
                        language: lang,
                        name: '',
                        id: '',
                    }));

                    setBudgets(initialBudgets);
                } else {
                    props.setDrawerVisible(false);
                }

                setLoading(false);
            });
        }
    }, [props.drawerVisible, props.mode]);




    const onFinish = (values: any) => {
        if (props.mode === "create") { // CREATE
            // Mapeo de budgets a TranslationData[]
            const translations: TranslationData[] = budgets.map((item) => ({
                language: item.language,
                value: item.name,
            }));

            const createBudgetDto: CreateBudgetDto = {
                names: translations,
            };

            setLoadingButton(true);
            createBudgetGroupForm(createBudgetDto).then((response) => {
                if (response?.type === 1) {
                    props.onSuccess?.();
                    closeDrawer();
                }
                setLoadingButton(false);

            });
        } else { // EDIT
            setLoadingButton(true);
            const d: EditBudgetDto = { names: budgets }
            editBudgetGroupForm(d).then((response) => {
                if (response?.type === 1) {
                    props.onSuccess?.();
                    closeDrawer();
                }
                setLoadingButton(false);
            });
        }
    };



    return (
        <div className='room-form-component'>
            {loading ? (
                <LoadingData />

            ) : (
                <Form form={form}
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <Row gutter={16}>
                        <Col xs={24} md={24}>
                            <Form.Item
                                name="budgetsValidator"
                                label={t("components.tab-configuration.group-form.fields.budget-name")}
                                required
                                rules={[
                                    {
                                        validator: async () => {
                                            if (budgets.length === 0 || budgets.every(b => !b.name.trim())) {
                                                return Promise.reject(
                                                    t("components.tab-mapping.room-config.drawer.name-required") ?? ""
                                                );
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                {(() => {
                                    const elements: JSX.Element[] = [];
                                    if (isArray) {
                                        budgets.forEach((item, optIndex) => {
                                            elements.push(
                                                <div key={item.id + item.language} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                                    <span>{item.language.toUpperCase().substring(0, 2)}</span>
                                                    <Input
                                                        value={item.name}
                                                        onChange={(e) => modifyBudgetName(optIndex, e.target.value)}
                                                        style={{ marginLeft: 8 }}
                                                    />
                                                </div>
                                            );
                                        });
                                    }
                                    return elements;
                                })()}

                            </Form.Item>
                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item style={{ textAlign: 'center', marginTop: 20 }}>
                                <Button className="app-white-button width-95" onClick={handleBtnCancel}>
                                    {t("components.button.cancel")}
                                </Button>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item style={{ textAlign: 'center', marginTop: 20 }}>
                                <Button
                                    className="app-button width-95"
                                    htmlType="submit"
                                    disabled={loadingButton || budgets.length === 0 || budgets.every(b => !b.name.trim())}
                                >
                                    {loadingButton ? <LoadingOutlined /> : t("components.button.save")}
                                </Button>
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            )}
        </div>
    );
};

export default BudgetForm